// @mui material components
import { ColorValues } from '@DStypes/colors';
import Box from '@mui/material/Box';
import { Palette, styled } from '@mui/material/styles';
import { BoxShadowValues } from '@theme/base/boxShadows';

export default styled(Box)<{ ownerState: any }>(({ theme, ownerState }) => {
  const { palette, functions, borders, boxShadows } = theme;
  const {
    variant,
    bgColor,
    color,
    opacity,
    borderRadius,
    shadow,
    coloredShadow,
    bordered
  }: {
    variant: string;
    bgColor: string;
    color: string;
    opacity: string;
    borderRadius: string;
    shadow: string;
    coloredShadow: string;
    bordered: boolean;
  } = ownerState;

  const { gradients, grey, white } = palette;
  const { linearGradient } = functions;
  const { borderRadius: radius, borderWidth, borderColor } = borders;
  const { colored } = boxShadows;

  const greyColors: { [key: string]: string } = {
    'grey-100': grey[100],
    'grey-200': grey[200],
    'grey-300': grey[300],
    'grey-400': grey[400],
    'grey-500': grey[500],
    'grey-600': grey[600],
    'grey-700': grey[700],
    'grey-800': grey[800],
    'grey-900': grey[900]
  };

  const validGradients = [
    'primary',
    'secondary',
    'info',
    'success',
    'warning',
    'error',
    'dark',
    'light',
    'grey',
    'highlight'
  ];

  const validColors = [
    'transparent',
    'white',
    'black',
    'primary',
    'secondary',
    'info',
    'success',
    'warning',
    'error',
    'light',
    'processed',
    'dark',
    'text',
    'grey-100',
    'grey-200',
    'grey-300',
    'grey-400',
    'grey-500',
    'grey-600',
    'grey-700',
    'grey-800',
    'grey-900'
  ];

  const validBorderRadius = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'section'];
  const validBoxShadows = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'inset'];

  // background value
  let backgroundValue: string = bgColor;

  if (variant === 'gradient')
    backgroundValue = validGradients.find((el) => el === bgColor)
      ? linearGradient(gradients[bgColor].main, gradients[bgColor].state)
      : white.main;
  else if (validColors.find((el) => el === bgColor))
    backgroundValue = palette[bgColor as keyof Palette]
      ? palette[bgColor as keyof Palette].main
      : greyColors[bgColor];
  else backgroundValue = bgColor;

  // color value
  let colorValue = color;

  if (validColors.find((el) => el === color))
    colorValue = palette[color as keyof Palette]
      ? palette[color as keyof Palette].main
      : greyColors[color];

  // borderRadius value
  let borderRadiusValue: string | number = borderRadius;

  if (validBorderRadius.find((el) => el === borderRadius))
    borderRadiusValue = radius[borderRadius];

  // boxShadow value
  let boxShadowValue = 'none';

  if (validBoxShadows.find((el) => el === shadow))
    boxShadowValue = boxShadows[shadow as keyof BoxShadowValues];
  else if (coloredShadow)
    boxShadowValue = colored[coloredShadow as keyof ColorValues]
      ? colored[coloredShadow as keyof ColorValues]
      : 'none';

  return {
    opacity,
    background: backgroundValue,
    color: colorValue,
    borderRadius: borderRadiusValue,
    boxShadow: boxShadowValue,
    border: bordered ? `${borderWidth[1]} solid ${borderColor}` : ''
  };
});
